export default "__VITE_ASSET__CJ9z450S__"